module.exports = __webpack_public_path__ + "img/target.a2f4731.svg";